import mYoya from "./yoya.svg";
// import mLogo from "./logos/yoyapay_logo.svg";
import mLogo from "./logo_new.svg";
import fLogo from "./logoWhite.svg";
import tab from "./tab.svg";
import banner from "./eWallet.svg";
// import logo_horizontal from "./logo_horizontal.svg";
import card from "./creditCard.svg";

export const YoyaSVG = mYoya;
export const LogoSVG = mLogo;
export const FLogoSVG = fLogo;
export const TabSVG = tab;
export const LogoHorizontalSVG = mLogo;
export const bannerSVG = banner;
export const CardSVG = card;
